import { ProductList } from "@/components/organisms/ProductList";
import type { MenuCategory } from "@/types";

export const Menu = () => {
  const handleCategorySelect = (category: MenuCategory) => {
    console.log("Category selected:", category);
    // TODO: Implement category filtering logic
  };

  const handleRefresh = () => {
    console.log("Refreshing menu data...");
    // Additional refresh logic can be added here if needed
  };

  return (
    <ProductList
      onCategorySelect={handleCategorySelect}
      onRefresh={handleRefresh}
      showCategoryNavigation={true}
    />
  );
};
